export default __webpack_public_path__ + "static/media/addBtn.e28fd225.svg";